import { atom } from 'recoil';

export const approveResponseState = atom<boolean>({
  key: 'approveResponse',
  default: false,
});

export const responseTypeIdIsConsultedInErrorState = atom<boolean>({
  key: 'responseTypeIdIsConsultedInError',
  default: false,
});

export const responseTypeIdState = atom<number | undefined>({
  key: 'responseTypeId',
  default: undefined,
});

export const responseDetailState = atom<string | undefined>({
  key: 'responseDetail',
  default: undefined,
});
